module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/410ccbdf0bbd12597c7152f64d44afca.jpg";